
import icon1 from '../images/service/icon/buildings1.svg'
import icon2 from '../images/service/icon/dining-room1.svg'
import icon18 from '../images/service/icon-4/property.svg'
import icon19 from '../images/service/icon-4/engineering.svg'

import sSimg1 from '../images/service-single/1.jpg'
import sSimg2 from '../images/service-single/2.jpg'
import sSimg3 from '../images/service-single/3.jpg'
import sSimg4 from '../images/service-single/4.jpg'
import pimg2 from "../images/project/work-2.png";
import pimg3 from "../images/project/work-3.png";

import pimg7 from "../images/project/work-7.png";
import pimg8 from "../images/project/work-8.png";
import pimg9 from "../images/project/work-9.png";
import pimg11 from "../images/project/work-11.png";
import pimg12 from "../images/project/work-12.png";
import pimg13 from "../images/project/work-13.png";
import pimg14 from "../images/project/work-14.png";

const Services = [

  /* ================= RESIDENTIAL ================= */

  {
    Id: '01',
    Icon: icon1,
    SImg: sSimg1,
    Simg2: pimg7,
    Simg3: pimg8,
    Simg4: pimg9,
    Simg5: pimg13,
    Simg6: pimg3,
    title: 'Residential',
    Subtitle: 'Apartments • Villas • Residential Plots',
    slug: 'residential-realty',

    overview:
      `Luxrock Realty provides reliable residential property services for families, working professionals, and investors seeking secure ownership and long-term value. Purchasing a home involves both emotional and financial commitment, therefore every property we present goes through document verification, ownership confirmation, and locality evaluation before recommendation.

Our residential portfolio includes ready-to-move apartments, independent villas, and approved residential plots in developing and established neighborhoods. We assist buyers in property selection, site visits, negotiation, loan coordination, and registration guidance. Sellers receive accurate market valuation and verified buyer handling, while tenants and landlords benefit from proper rental agreements and background verification.

Our objective is simple — every client should complete the transaction with full legal clarity, transparent pricing, and complete confidence.`,

    innerServices: [
      {
        name: 'Apartments & Villas',
        description: 'Verified residential homes in well-connected locations with clear ownership and resale potential.',
      },
      {
        name: 'Weekend & Investment Homes',
        description: 'Independent properties suitable for personal use or long-term appreciation.',
      },
      {
        name: 'Residential Plots',
        description: 'Approved plotting schemes suitable for safe construction and future development.',
      },
    ],

    serviceTypes: [
      {
        type: 'Buy',
        description: 'Property shortlisting, site visits, negotiation assistance, bank loan coordination, and registration guidance.',
      },
      {
        type: 'Sell',
        description: 'Market valuation, professional marketing, buyer verification, and end-to-end transaction handling.',
      },
      {
        type: 'Rent',
        description: 'Tenant sourcing, background checks, agreement drafting, and possession coordination.',
      },
    ],

    highlights: [
      'Title Verification Guidance',
      'Transparent Deal Process',
      'Loan & Registration Support',
      'Local Market Expertise',
    ],

    seo: {
      title: 'Residential Property Buy Sell Rent | Luxrock Realty',
      description:
        'Verified apartments, villas, and residential plots with proper documentation support and transparent real estate guidance.',
    },
  },

  /* ================= COMMERCIAL ================= */

  {
    Id: '02',
    Icon: icon2,
    SImg: sSimg2,
    Simg2: pimg2,
    Simg3: pimg11,
    Simg4: pimg14,
    Simg5: pimg13,
    Simg6: pimg12,

    title: 'Commercial',
    Subtitle: 'Shops • Showrooms • Offices • Commercial Land',
    slug: 'commercial-realty',

    overview:
      `Luxrock Realty assists businesses and investors in securing commercial properties that offer visibility, accessibility, and stable returns. Commercial real estate decisions directly affect business performance, therefore we evaluate each property based on location strength, surrounding activity, rental demand, and legal compliance.

We deal in retail shops, branded showrooms, office spaces, co-working units, and commercial plots. Investors receive proper rental yield understanding and risk clarity before purchase. Business owners are guided in selecting spaces suitable for operations and long-term growth.

From property identification to documentation and possession, our team ensures smooth and transparent transactions designed for business continuity and investment security.`,

    innerServices: [
      {
        name: 'Retail Shops',
        description: 'Commercial spaces suitable for daily business operations and customer walk-ins.',
      },
      {
        name: 'Showrooms',
        description: 'High-visibility commercial frontage properties for brand presence.',
      },
      {
        name: 'Office Spaces',
        description: 'Professional workspaces for corporate, startup, and service businesses.',
      },
      {
        name: 'Commercial Plots',
        description: 'Development-suitable land parcels for long-term commercial investment.',
      },
    ],

    serviceTypes: [
      {
        type: 'Buy',
        description: 'Location analysis, ROI understanding, documentation review, and transaction support.',
      },
      {
        type: 'Sell',
        description: 'Targeted buyer outreach, pricing strategy, and structured closure assistance.',
      },
      {
        type: 'Rent',
        description: 'Tenant matching, lease coordination, and agreement documentation.',
      },
      {
        type: 'Pre-Lease',
        description: 'Investment opportunities in leased commercial assets generating regular income.',
      },
    ],

    highlights: [
      'Business Location Guidance',
      'Rental Yield Understanding',
      'Verified Commercial Deals',
      'Investor-Focused Advisory',
    ],

    seo: {
      title: 'Commercial Property Buy Sell Lease | Luxrock Realty',
      description:
        'Shops, offices, showrooms and commercial land with proper documentation and investment clarity.',
    },
  },
  /* ================= AGRICULTURE ================= */

  {
    Id: '04',
    Icon: icon19,
    SImg: sSimg4,
    Simg2: pimg7,
    Simg3: pimg8,
    Simg4: pimg9,
    Simg5: pimg13,
    Simg6: pimg3,
    title: 'Agriculture Land',
    Subtitle: 'Farmland • Investment Land • NA Conversion Guidance',
    slug: 'agriculture-land',

    overview:
      `Luxrock Realty assists clients in safely dealing with agricultural land transactions through proper record understanding and procedural guidance. Agricultural properties require careful verification of ownership history, zoning rules, and permitted usage, therefore we prioritize clarity before commitment.

We help buyers identify suitable farmland, long-term holding land, and investment parcels. Landowners receive support in valuation and structured selling. Where permitted, we guide clients regarding procedural understanding of land use conversion processes.

Our approach ensures clients make informed land decisions without documentation confusion or unexpected legal complications.`,

    innerServices: [
      {
        name: 'Agriculture Farmland',
        description: 'Land suitable for cultivation and agricultural usage.',
      },
      {
        name: 'Investment Land',
        description: 'Long-term holding parcels with appreciation potential.',
      },
      {
        name: 'NA Conversion Support',
        description: 'Process guidance related to permissible land use conversion procedures.',
      },
    ],

    serviceTypes: [
      {
        type: 'Buy',
        description: 'Ownership record review and purchase guidance.',
      },
      {
        type: 'Sell',
        description: 'Buyer coordination and structured transaction handling.',
      },
      {
        type: 'Rent',
        description: 'Agricultural leasing coordination and agreement assistance.',
      },
    ],

    highlights: [
      'Record Clarity Guidance',
      'Safe Land Transactions',
      'Investment Perspective Support',
      'Local Process Understanding',
    ],

    seo: {
      title: 'Agriculture Land Buy Sell Rent | Luxrock Realty',
      description:
        'Agricultural land transactions with ownership clarity and proper process understanding.',
    },
  },
  /* ================= INDUSTRIAL ================= */

  {
    Id: '03',
    Icon: icon18,
    SImg: sSimg3,
    Simg2: pimg7,
    Simg3: pimg8,
    Simg4: pimg9,
    Simg5: pimg13,
    Simg6: pimg3,

    title: 'Investment',
    Subtitle: 'Rental Income • Capital Growth • Smart Asset Planning',
    slug: 'investment-realty',

    overview:
      `Luxrock Realty provides strategic real estate investment guidance focused on stable income generation and long-term capital growth. We help investors select assets based on future development potential, demand trends, and market timing rather than speculation.

Our team identifies opportunities across pre-leased assets, under-construction projects, commercial spaces, and future growth corridors. Each investment is evaluated for rental yield, appreciation probability, holding period suitability, and liquidity.

From opportunity selection to documentation and transaction execution, we ensure investors build secure and profitable property portfolios with clarity and confidence.`,

    innerServices: [
      {
        name: 'Pre-Leased Properties',
        description: 'Ready income-generating assets with existing tenants and assured rental returns.',
      },
      {
        name: 'Pre-Launch & Under-Construction Projects',
        description: 'Early-stage investment opportunities offering lower entry price and higher appreciation potential.',
      },
      {
        name: 'Dual Benefit Investments',
        description: 'Properties selected for both monthly rental income and long-term capital appreciation.',
      },
    ],

    serviceTypes: [
      {
        type: 'Commercial Real Estate',
        description: 'Shops, offices, and business spaces designed for higher rental yields and stable tenants.',
      },
      {
        type: 'Land & Future Growth Plots',
        description: 'Plots located near upcoming infrastructure zones and expanding development corridors.',
      },
      {
        type: 'Portfolio Building',
        description: 'Balanced mix of rental and appreciation assets for long-term wealth creation.',
      },
      {
        type: 'Investment Exit Planning',
        description: 'Guidance on resale timing to maximize profits and market advantage.',
      },
    ],

    highlights: [
      'Pre-Leased Rental Assets',
      'Early-Stage Project Entry',
      'High Yield Commercial Spaces',
      'Future Infrastructure Growth Areas',
    ],

    seo: {
      title: 'Real Estate Investment Advisory | Luxrock Realty',
      description:
        'Strategic property investment in pre-leased assets, commercial spaces, plots and under-construction projects for rental income and appreciation.',
    },
  }




];

export default Services;

